module.exports = __webpack_public_path__ + "media/images/e-bilet/Bg_train_registration-70564883f382f1924cb40554f8374fb5.png";